import Calculator from "./Calculator";

export default Calculator